export const checksums = {
  "nieuws": "v3.5.0--AVPoOa5dg_GBHEWgSfsCLuGGd3JcWkYceFGYRkhxqG4",
  "content": "v3.5.0--wK9Iy5Q6C8TAD4hUkTAtM_jF_nZidYnFyb447R-dpdk"
}
export const checksumsStructure = {
  "nieuws": "GOmBw2-tkENYC4k3j1YxAx-c8YWmUuRQLxHq-C-RroA",
  "content": "-G8s_pK468pKaRFGPXCKe0_CmCQVR80F8rCMSZm-Hd0"
}

export const tables = {
  "nieuws": "_content_nieuws",
  "content": "_content_content",
  "info": "_content_info"
}

export default {
  "nieuws": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "category": "string",
      "date": "date",
      "description": "string",
      "extension": "string",
      "head": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "schemaOrg": "json",
      "seo": "json",
      "stem": "string"
    }
  },
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "head": "json",
      "meta": "json",
      "navigation": "json",
      "pagetype": "string",
      "path": "string",
      "public": "boolean",
      "schemaOrg": "json",
      "seo": "json",
      "stem": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}